<script lang="ts">
    import type { RadioEquipmentRegulation } from '@shared/types/types.ts';

    interface Props {
        radioEquipmentRegulation: RadioEquipmentRegulation | undefined;
    }

    let { radioEquipmentRegulation }: Props = $props();
</script>

{#if radioEquipmentRegulation}
    <ofc-radio-equipment-regulation-v1
        min-power={radioEquipmentRegulation.minChargingPowerWatt}
        max-power={radioEquipmentRegulation.maxChargingPowerWatt}
        charging-device={radioEquipmentRegulation.chargingDeviceIncluded ? true : undefined}
        usb-pd={radioEquipmentRegulation.supportsUsbPowerDelivery ? true : undefined}
    >
    </ofc-radio-equipment-regulation-v1>
{/if}
